import * as types from "./actionTypes";


export const loadAssetSuccess = (assets: any) => {
  return { type: types.LOAD_ASSET_SUCCESS, assets: assets.assets };
}

export const loadAssetStart = () => {
  return { type: types.START_LOAD_SUBSCRIPTIONREQUEST };
}



// WEBPACK FOOTER //
// ./src/modules/core/actions/assetActions.tsx